import Form from "@/views/App/Portal/PrivateCoaching/FirstInterview/Form.vue";
import GoWorkMobileForm from "@/views/App/Portal/PrivateCoaching/FirstInterview/GoWorkMobileForm.vue";
import MICForm from "@/views/App/Portal/PrivateCoaching/FirstInterview/MICForm.vue";
import MicFormV2 from "@/views/App/Portal/PrivateCoaching/FirstInterview/MICFormV2.vue";

import ProtocolList from "@/views/App/Portal/PrivateCoaching/Protocol/Regular/List.vue";
import ProtocolGoWorkMobileList from "@/views/App/Portal/PrivateCoaching/Protocol/GoWorkMobile/List.vue";
import ProtocolMICList from "@/views/App/Portal/PrivateCoaching/Protocol/MIC/List.vue";
import ProtocolMICV2List from "@/views/App/Portal/PrivateCoaching/Protocol/MICV2/List.vue";
import FirstAppointmentList from "@/views/App/Portal/PrivateCoaching/InvitationToFirstAppointment/List.vue";
import InterimReportList from "@/views/App/Portal/PrivateCoaching/InterimReport/List.vue";
import FinalInterviewForm from "@/views/App/Portal/PrivateCoaching/FinalInterview/Form.vue";
import IntroductionDocumentsForm from "@/views/App/Portal/PrivateCoaching/IntroductoryDocuments/Form.vue";
import MeetingList from "@/views/App/Portal/PrivateCoaching/MeetingList/List.vue";
import ModuleList from "@/views/App/Portal/PrivateCoaching/ModuleGoals/List.vue";

const routesPortalPrivateCoaching = [
    {
        path: 'first-interview/:id',
        name: 'privateCoachingFirstInterviewForm',
        component: Form
    },
    {
        path: 'first-interview/go-work-mobile/:id',
        name: 'privateCoachingGoWorkMobileFirstInterviewForm',
        component: GoWorkMobileForm
    },
    {
        path: 'first-interview/mic/:id',
        name: 'privateCoachingMicFirstInterviewForm',
        component: MICForm
    },
    {
        path: 'first-interview/mic-v2/:id',
        name: 'privateCoachingMicFirstInterviewV2Form',
        component: MicFormV2
    },
    {
        path: 'protocol/:id',
        name: 'privateCoachingProtocolList',
        component: ProtocolList
    },
    {
        path: 'protocol-go-work-mobile/:id',
        name: 'privateCoachingProtocolGoWorkMobileList',
        component: ProtocolGoWorkMobileList
    },
    {
        path: 'protocol-mic/:id',
        name: 'privateCoachingMICList',
        component: ProtocolMICList
    },
    {
        path: 'protocol-mic-v2/:id',
        name: 'privateCoachingMICV2List',
        component: ProtocolMICV2List
    },
    {
        path: 'invitation-to-first-appointment-list/:id',
        name: 'privateCoachingInvitationToFirstAppointmentList',
        component: FirstAppointmentList
    },
    {
        path: 'interim-report-list/:id',
        name: 'privateCoachingInterimReportList',
        component: InterimReportList
    },
    {
        path: 'final-interview/:id',
        name: 'privateCoachingFinalInterview',
        component: FinalInterviewForm
    },
    {
        path: 'introduction-documents/:id',
        name: 'privateCoachingIntroductionDocuments',
        component: IntroductionDocumentsForm
    },
    {
        path: 'meeting-list/:id',
        name: 'privateCoachingMeetingList',
        component: MeetingList
    },
    {
        path: 'module-list/:id',
        name: 'privateCoachingModuleList',
        component: ModuleList
    },
];

export default routesPortalPrivateCoaching;